/**
 * List-view variant picker: sync swatches → variant id, price, image, ATC state.
 */
(function(){
  if (typeof window.jQuery === 'undefined') return;
  var $ = window.jQuery;

  function moneyFormat(){
    return (theme && theme.moneyFormat) ? theme.moneyFormat : '${{amount}}';
  }

  function formatMoney(cents){
    if (theme.Currency && typeof theme.Currency.formatMoney === 'function'){
      return theme.Currency.formatMoney(cents, moneyFormat());
    }
    return (cents / 100).toFixed(2);
  }

  function getProduct($item){
    var id = $item.find('.lv-variant-form').data('product-id');
    var el = document.getElementById('listProductJson-' + id);
    if (!el) return null;
    try { return JSON.parse(el.innerHTML); } catch (e){ return null; }
  }

  function getSelectedOptions($form){
    var options = [];
    $form.find('.swatch').each(function(){
      var $checked = $(this).find('.swatchInput:checked');
      if ($checked.length){
        options.push($checked.val());
        $(this).find('.slVariant').text($checked.val());
      }
    });
    return options;
  }

  function findVariant(product, selected){
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++){
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < selected.length; j++){
        if (String(v.options[j]) !== String(selected[j])){
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function uniq(arr){
    var out = [];
    for (var i = 0; i < arr.length; i++){
      if ($.inArray(arr[i], out) === -1) out.push(arr[i]);
    }
    return out;
  }

  function buildOptionsMap(product){
    var map = {};
    for (var i = 0; i < product.variants.length; i++){
      var variant = product.variants[i];
      if (!variant.available) continue;

      map.root = map.root || [];
      map.root.push(variant.option1);
      map.root = uniq(map.root);

      if (product.options.length > 1){
        var key1 = variant.option1;
        map[key1] = map[key1] || [];
        map[key1].push(variant.option2);
        map[key1] = uniq(map[key1]);
      }
      if (product.options.length === 3){
        var key2 = variant.option1 + ' / ' + variant.option2;
        map[key2] = map[key2] || [];
        map[key2].push(variant.option3);
        map[key2] = uniq(map[key2]);
      }
    }
    return map;
  }

  function updateSoldoutState($form, product, optionsMap){
    if (!product || product.options.length < 2){
      if (product && product.options.length === 1){
        product.variants.forEach(function(variant){
          if (!variant.available){
            $form.find('.swatch-element').filter(function(){
              return String($(this).data('value')) === String(variant.title);
            }).addClass('soldout');
          }
        });
      }
      return;
    }

    var opt0 = $form.find('.pvOpt0 .swatchInput:checked').val();
    var opt1 = $form.find('.pvOpt1 .swatchInput:checked').val();

    // Option 0
    var rootOpts = optionsMap.root || [];
    $form.find('.pvOpt0 .swatch-element').each(function(){
      var val = String($(this).data('value'));
      $(this).toggleClass('soldout', $.inArray(val, rootOpts) === -1);
    });

    // Option 1
    if (product.options.length > 1){
      var avail1 = optionsMap[opt0] || [];
      $form.find('.pvOpt1 .swatch-element').each(function(){
        var val = String($(this).data('value'));
        $(this).toggleClass('soldout', $.inArray(val, avail1) === -1);
      });
      if (avail1.length && $.inArray(String(opt1), avail1) === -1){
        var $first = $form.find('.pvOpt1 .swatch-element').not('.soldout').first().find('.swatchInput');
        if ($first.length) $first.prop('checked', true);
        opt1 = $form.find('.pvOpt1 .swatchInput:checked').val();
      }
    }

    // Option 2
    if (product.options.length === 3){
      var key = opt0 + ' / ' + opt1;
      var avail2 = optionsMap[key] || [];
      var opt2 = $form.find('.pvOpt2 .swatchInput:checked').val();
      $form.find('.pvOpt2 .swatch-element').each(function(){
        var val = String($(this).data('value'));
        $(this).toggleClass('soldout', $.inArray(val, avail2) === -1);
      });
      if (avail2.length && $.inArray(String(opt2), avail2) === -1){
        var $first2 = $form.find('.pvOpt2 .swatch-element').not('.soldout').first().find('.swatchInput');
        if ($first2.length) $first2.prop('checked', true);
      }
    }
  }

  function updatePrice($item, variant){
    var $price = $item.find('.lv_price');
    if (!$price.length || !variant) return;

    var priceHtml = '';
    var priceMoney = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price){
      priceHtml = '<div class="price">' +
        '<s class="pr_price">' + formatMoney(variant.compare_at_price) + '</s> ' +
        '<span class="pr_price sale">' + priceMoney + '</span>' +
        '</div>';
    } else {
      priceHtml = '<div class="price"><span class="pr_price">' + priceMoney + '</span></div>';
    }
    $price.html(priceHtml);

    if (theme.mlcurrency && typeof currenciesChange === 'function'){
      currenciesChange($price.find('span.money, .pr_price'));
    }
  }

  function updateImage($item, variant){
    if (!variant || !variant.featured_image) return;
    var src = variant.featured_image.src || variant.featured_image;
    if (!src || typeof src !== 'string') return;
    var $img = $item.find('.lv_product_img');
    if (!$img.length) return;

    var sized = src;
    if (theme.Images && typeof theme.Images.getSizedImageUrl === 'function'){
      sized = theme.Images.getSizedImageUrl(src, '400x') || src;
    }
    $img.css('background-image', 'url(' + sized + ')');
    $img.attr('data-bgset', sized);
  }

  function updateAddToCart($form, variant){
    var $btn = $form.find('[type="submit"]');
    var $txt = $btn.find('.txt');
    if (!variant){
      $btn.prop('disabled', true);
      $txt.text((theme.strings && theme.strings.unavailable) || 'Unavailable');
      return;
    }
    if (variant.available){
      $btn.prop('disabled', false);
      var qty = variant.inventory_quantity;
      if (qty < 1 && variant.inventory_management === 'shopify'){
        $txt.text((theme.strings && theme.strings.preOrder) || (theme.strings && theme.strings.addToCart) || 'Add to cart');
      } else {
        $txt.text((theme.strings && theme.strings.addToCart) || 'Add to cart');
      }
    } else {
      $btn.prop('disabled', true);
      $txt.text((theme.strings && theme.strings.soldOut) || 'Sold out');
    }
  }

  function syncVariant($item){
    var $form = $item.find('.lv-variant-form form');
    if (!$form.length) return;

    var product = $item.data('lvProduct');
    var optionsMap = $item.data('lvOptionsMap');
    if (!product){
      product = getProduct($item);
      if (!product) return;
      $item.data('lvProduct', product);
      optionsMap = buildOptionsMap(product);
      $item.data('lvOptionsMap', optionsMap);
    }

    updateSoldoutState($form, product, optionsMap);

    var selected = getSelectedOptions($form);
    var variant = findVariant(product, selected);

    if (variant){
      $form.find('select[name="id"]').val(variant.id);
      updatePrice($item, variant);
      updateImage($item, variant);
    }
    updateAddToCart($form, variant);
  }

  function initListVariants(root){
    var $root = root ? $(root) : $(document);
    $root.find('.lv_item').has('.lv-variant-form').not('[data-lv-ready]').each(function(){
      var $item = $(this);
      var product = getProduct($item);
      if (!product) return;
      $item.data('lvProduct', product);
      $item.data('lvOptionsMap', buildOptionsMap(product));
      $item.attr('data-lv-ready', '1');
      syncVariant($item);
    });
  }

  theme.initListVariants = initListVariants;

  $(document).on('change', '.lv_item .lv-variant-form .swatchInput', function(){
    syncVariant($(this).closest('.lv_item'));
  });

  // Prevent selecting sold-out swatches
  $(document).on('click', '.lv_item .lv-variant-form .swatch-element.soldout', function(e){
    e.preventDefault();
    return false;
  });

  $(function(){
    initListVariants();

    var collectionPr = document.getElementById('collectionPr');
    if (collectionPr && window.MutationObserver){
      var timer = null;
      new MutationObserver(function(){
        clearTimeout(timer);
        timer = setTimeout(function(){ initListVariants(collectionPr); }, 50);
      }).observe(collectionPr, { childList: true, subtree: true });
    }
  });
})();
